import type { FC, ReactNode } from 'react'
import type { Article } from '@/types'

import { SectionLabel } from '@/components/generals/section-label'
import { ArticleRow } from '@/components/journal/article-card'

interface ArticleNextProps {
    articles: Article[]
}

/* Closing rows: the three pieces that follow this one in the journal, wrapping
   back to the top of the list when it runs out. */
export const ArticleNext: FC<ArticleNextProps> = ({ articles }): ReactNode => {
    return (
        <section
            id='article-next'
            aria-label='Keep reading'
            className='mx-auto w-full max-w-[1920px] px-5 pb-14 pt-4 text-ink lg:px-[33px] lg:pb-[104px] lg:pt-6'
        >
            <div className='grid gap-8 lg:grid-cols-4 lg:gap-5'>
                <SectionLabel label='Keep reading' className='h-fit lg:col-span-1' />

                <ul className='flex flex-col lg:col-span-3'>
                    {articles.map((article) => (
                        <ArticleRow key={article.slug} article={article} />
                    ))}

                    <span
                        data-journal-rule
                        aria-hidden='true'
                        className='block h-px w-full origin-left bg-current opacity-15'
                    />
                </ul>
            </div>
        </section>
    )
}
